export enum RewardUnitType {
    Cash = 'Cash',
    Percentage = 'Percentage',
    GenericReward = 'GenericReward',
    Credit = 'Credit'
  }
